const de = {
  pleaseEnterUsername: "Bitte geben Sie einen Benutzernamen ein",
  cannotFriendYourself: "Sie können sich selbst keine Freundschaftsanfrage senden.",
  friendRequestSent: "Freundschaftsanfrage gesendet!",
  failedToSendRequest: "Anfrage konnte nicht gesendet werden",
  linkCopied: "Link in die Zwischenablage kopiert!",
  backToInvites: "Zurück zu Einladungen",
  sendFriendRequestByUsername: "Freundschaftsanfrage per Benutzername senden",
  enterUsername: "Benutzername eingeben",
  send: "Senden",
  yourInviteQrCode: "Ihr Einladungs-QR-Code",
  inviteLink: "Einladungslink",
  scanQrOrUseLink: "Scannen Sie diesen QR-Code oder verwenden Sie diesen Link, um eine Freundschaftsanfrage zu senden",
  copyInviteLink: "Einladungslink kopieren",
  goToItem: "Zum Element",
  verificationEmailSent: "Bestätigungs-E-Mail gesendet! Bitte überprüfen Sie Ihren Posteingang.",
  verificationEmailFailed: "Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
  verifyYourEmail: "E-Mail-Adresse bestätigen",
  verifyEmailInstructions: "Bitte bestätigen Sie Ihre E-Mail-Adresse, um auf Ihr Konto zuzugreifen. Überprüfen Sie Ihren Posteingang auf den Bestätigungslink.",
  sending: "Wird gesendet...",
  resendVerificationEmail: "Bestätigungs-E-Mail erneut senden",
  login: "Anmelden",
  register: "Registrieren",
  home: "Startseite",
  calendar: "Kalender",
  friends: "Freunde",
  profile: "Profil",
  logout: "Abmelden",
  loading: "Wird geladen...",
  language: "Sprache",
  calendarSelectPlaceSuggestion: "Bitte wählen Sie einen Ort aus den Vorschlägen aus, damit die Koordinaten übernommen werden.",
  calendarSelectDateAndTime: "Bitte wählen Sie Datum und Uhrzeit aus.",
  calendarPositiveDuration: "Bitte geben Sie eine positive Dauer an.",
  calendarFutureDateRequired: "Datum und Uhrzeit des Ereignisses müssen in der Zukunft liegen.",
  calendarCreateEventFailed: "Ereignis konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
  cancel: "Abbrechen",
  createNewEvent: "Neues Ereignis erstellen",
  week: "Woche",
  month: "Monat",
  eventTitle: "Titel",
  date: "Datum",
  time: "Uhrzeit",
  duration: "Dauer",
  endsAt: "Endet um",
  place: "Ort",
  searchForPlace: "Ort suchen",
  placeSearchTip: "Tipp: Geben Sie einen Ort ein und wählen Sie ein Ergebnis aus, um Koordinaten anzuhängen.",
  description: "Beschreibung",
  createEvent: "Ereignis erstellen",
  today: "Heute",
  previousMonth: "Vorheriger Monat",
  nextMonth: "Nächster Monat",
  previous: "Zurück",
  next: "Weiter",
  mondayShort: "Mo",
  tuesdayShort: "Di",
  wednesdayShort: "Mi",
  thursdayShort: "Do",
  fridayShort: "Fr",
  saturdayShort: "Sa",
  sundayShort: "So",
  more: "mehr",
  mustRespondWillBeforeReposting: "Sie müssen mit „Werde teilnehmen“ antworten, bevor Sie erneut teilen können",
  event: "Ereignis",
  backToCalendar: "Zurück zum Kalender",
  addToGoogleCalendar: "Zu Google Kalender hinzufügen",
  when: "Wann",
  where: "Wo",
  openLocationInGoogleMaps: "Ort in Google Maps öffnen",
  hosts: "Gastgeber",
  yourResponse: "Ihre Antwort",
  currentResponse: "Aktuelle Antwort",
  response_will: "Werde teilnehmen",
  response_might: "Vielleicht teilnehmen",
  response_wont: "Werde nicht teilnehmen",
  willRunIntoYou: "Ich komme vorbei",
  mightDropBy: "Vielleicht komme ich vorbei",
  wontCome: "Ich komme nicht",
  repostToMyFriends: "Mit meinen Freunden teilen",
  responses: "Antworten",
  willAttend: "Wird teilnehmen",
  reposted: "Geteilt",
  mightAttend: "Nimmt vielleicht teil",
  cancelEvent: "Ereignis absagen",
  cancellationEmailNoticeBefore: "Teilnehmer, die zugesagt haben,",
  cancellationEmailNoticeAfter: "werden per E-Mail über die Absage informiert.",
  optionalCancellationMessage: "Optionale Nachricht an Teilnehmer (max. 1000 Zeichen)",
  confirmCancelEvent: "Absage des Ereignisses bestätigen",
  clear: "Löschen",
  confirmCancellation: "Absage bestätigen",
  confirmCancellationMessage: "Möchten Sie dieses Ereignis wirklich absagen? Bestätigte Teilnehmer werden benachrichtigt und das Ereignis wird entfernt.",
  eventCancelledNotified: "Ereignis abgesagt. Benachrichtigt:",
  attendees: "Teilnehmer",
  failedToCancelEvent: "Ereignis konnte nicht abgesagt werden",
  back: "Zurück",
  cancelled: "Abgesagt",
  ok: "OK",
  forgotPassword: "Passwort vergessen",
  email: "E-Mail",
  passwordResetLinkSent: "Falls ein Konto existiert, wurde ein Link zum Zurücksetzen gesendet.",
  passwordResetRequestFailed: "Anfrage zum Zurücksetzen des Passworts fehlgeschlagen.",
  sendResetLink: "Link zum Zurücksetzen senden",
  addFriend: "Freund hinzufügen",
  incomingRequests: "Eingehende Anfragen",
  accept: "Akzeptieren",
  deny: "Ablehnen",
  myFriends: "Meine Freunde",
  noFriendsYet: "Noch keine Freunde. Fügen Sie welche hinzu!",
  seeProfile: "Profil anzeigen",
  noEventsToRespondTo: "Keine Ereignisse zum Antworten",
  allCaughtUp: "Alles erledigt. Schauen Sie später wieder vorbei, um neue Ereignisse Ihrer Freunde zu sehen.",
  events: "Ereignisse",
  unknown: "Unbekannt",
  noDescriptionProvided: "Keine Beschreibung vorhanden.",
  will: "Ja",
  maybe: "Vielleicht",
  wont: "Nein",
  userNotFound: "Benutzer nicht gefunden",
  friendRequestSentSuccessfully: "Freundschaftsanfrage erfolgreich gesendet!",
  friendInvitation: "Freundschaftseinladung",
  sendFriendRequest: "Freundschaftsanfrage senden",
  loginToSendFriendRequest: "Bitte melden Sie sich an, um eine Freundschaftsanfrage zu senden",
  chooseLanguage: "Sprache auswählen",
  invalidCredentials: "Ungültige Anmeldedaten. Bitte versuchen Sie es erneut.",
  username: "Benutzername",
  password: "Passwort",
  forgotPasswordQuestion: "Passwort vergessen?",
  dontHaveAccount: "Noch kein Konto?",
  registerHere: "Hier registrieren",
  invalidProfilePhotoType: "Ungültiger Dateityp. Bitte laden Sie ein JPEG-, PNG-, GIF- oder WebP-Bild hoch.",
  invalidFileExtension: "Ungültige Dateiendung",
  allowedExtensions: "Erlaubt",
  fileTooLarge: "Datei zu groß",
  maximumFileSize: "Maximum",
  profilePhotoRemoved: "Profilbild entfernt.",
  failedToRemoveProfilePhoto: "Profilbild konnte nicht entfernt werden",
  profileUpdatedSuccessfully: "Profil erfolgreich aktualisiert!",
  failedToUpdateProfile: "Profil konnte nicht aktualisiert werden",
  privateEmailExplanation: "Nur Sie können Ihre E-Mail-Adresse sehen, um unerwünschte Nachrichten außerhalb der Plattform zu vermeiden",
  yourEmailIsPrivate: "Ihre E-Mail-Adresse ist privat.",
  profilePhoto: "Profilbild",
  removePhoto: "Foto entfernen",
  firstName: "Vorname",
  lastName: "Nachname",
  tellPeopleAboutYourself: "Erzählen Sie etwas über sich",
  whereToContactMe: "Kontaktmöglichkeiten",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Speichern",
  notSet: "Nicht festgelegt",
  editProfile: "Profil bearbeiten",
  imageToCrop: "Bild zum Zuschneiden",
  zoom: "Zoom",
  usePhoto: "Foto verwenden",
  name: "Name",
  whereToContact: "Kontakt",
  removeFriendship: "Freundschaft entfernen",
  confirmRemoveFriend: "Freund entfernen bestätigen",
  confirmRemoveFriendBefore: "Möchten Sie",
  confirmRemoveFriendAfter: "wirklich aus Ihrer Freundesliste entfernen?",
  friendRemoved: "Freund entfernt.",
  failedToRemoveFriend: "Freund konnte nicht entfernt werden.",
  confirmRemove: "Entfernen bestätigen",
  error: "Fehler",
  removed: "Entfernt",
  passwordsDoNotMatch: "Passwörter stimmen nicht überein",
  registrationFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  confirmPassword: "Passwort bestätigen",
  alreadyHaveAccount: "Haben Sie bereits ein Konto?",
  loginHere: "Hier anmelden",
  passwordResetSuccessfully: "Passwort erfolgreich zurückgesetzt.",
  failedToResetPassword: "Passwort konnte nicht zurückgesetzt werden.",
  resetPassword: "Passwort zurücksetzen",
  newPassword: "Neues Passwort",
  confirmNewPassword: "Neues Passwort bestätigen",
  setNewPassword: "Neues Passwort festlegen",
  emailVerifiedSuccessfully: "E-Mail erfolgreich bestätigt!",
  emailVerificationFailed: "Bestätigung fehlgeschlagen. Der Link ist möglicherweise ungültig oder abgelaufen.",
  verifying: "Wird bestätigt...",
  verified: "Bestätigt!",
  redirectingToHome: "Weiterleitung zur Startseite...",
  verificationFailed: "Bestätigung fehlgeschlagen",
  goToHome: "Zur Startseite",
  about: "Über",
  aboutConceptTitle: "Konzept",
  aboutCreatorIntroduction: "Hallo, ich bin Crypt0, Kletterer und Entwickler von Run Into Me.",
  aboutCreatorStory: "Ich habe diese Website erstellt, weil ich sehr kontaktfreudig bin und zwischen zwei Kletterrouten ständig mit anderen Kletterern ins Gespräch komme. Dadurch sammelten sich viele Telefonnummern an und ich verbrachte viel Freizeit mit der Planung gemeinsamer Klettertermine.",
  aboutPlanningProblem: "Ich wollte nicht länger jede Einheit planen und jeden Freund einzeln anschreiben, sondern allen gleichzeitig mitteilen, wann und wo ich klettere, ohne sie förmlich einzuladen.",
  aboutDeveloperSolution: "Dann fiel mir ein, dass ich Entwickler bin und selbst eine Lösung bauen kann.",
  aboutWelcome: "Willkommen bei Run Into Me. Hier erfahren deine Freunde, wann du eine Aktivität machst, an der sie ungezwungen teilnehmen können.",
  aboutCallToAction: "Wenn du das nächste Mal etwas planst, das allein möglich, gemeinsam aber schöner ist, veröffentliche es hier für deine Freunde!",
  aboutTutorialTitle: "Anleitung",
  aboutCalendarCreateEvent: "Im Kalender kannst du auch ein neues Ereignis erstellen.",
  aboutEventColorsIntroduction: "Die Ereignisfarben zeigen deinen Teilnahmestatus:",
  aboutColorGold: "Gold",
  aboutColorGoldDescription: "Du organisierst dieses Ereignis.",
  aboutColorGreen: "Grün",
  aboutColorGreenDescription: "Du nimmst an diesem Ereignis teil.",
  aboutColorOrange: "Orange",
  aboutColorOrangeDescription: "Du hast mit „Vielleicht“ geantwortet.",
  aboutColorBlue: "Blau",
  aboutColorBlueDescription: "Du hast noch nicht geantwortet.",
  aboutColorGray: "Grau",
  aboutColorGrayDescription: "Du hast die Einladung abgelehnt.",
  aboutCalendarEventDetails: "Klicke auf ein Ereignis, um weitere Informationen anzuzeigen und zu antworten.",
  aboutFriendPageTitle: "Freundeseite",
  aboutFriendPageDescription: "Gib zum Hinzufügen eines Freundes den Benutzernamen ein oder sende deinen Einladungslink / QR-Code.",
  aboutHomePageTitle: "Startseite",
  aboutHomePageDescription: "Durchsuche die kommenden Ereignisse deiner Freunde und teile ihnen mit, ob du kommst.",
  aboutRepostScreenTitle: "Repost-Seite",
  aboutGoogleCalendarDescription: "Füge das Ereignis mit dieser Schaltfläche zu Google Kalender hinzu.",
  aboutRepostDescription: "Nach deiner Zusage kannst du das Ereignis für deine Freunde reposten.",
};

export default de;